// Keep in sync with backend validation for instrumentExperience @Size(max = 6)
export const MAX_INSTRUMENT_FILTERS = 6;
// Keep in sync with backend validation for preferredStyles @Size(max = 12)
export const MAX_STYLE_FILTERS = 12;
// Keep in sync with backend validation for preferredStyles elements @Size(max = 100)
export const MAX_PREFERRED_STYLE_LENGTH = 100;
// Keep in sync with backend validation for locationRadiusMiles @DecimalMin/@DecimalMax
export const MIN_LOCATION_RADIUS_MILES = 1;
export const MAX_LOCATION_RADIUS_MILES = 250;
export const MIN_LOCATION_RADIUS_SLIDER_MILES = 0;
export const DEFAULT_USER_DISCOVER_PAGE_SIZE = 24;
export const DEFAULT_FRIENDSHIP_PAGE_SIZE = 24;
export const DEFAULT_BAND_CATALOG_PAGE_SIZE = 24;
